module.exports = require('./vendor/dat.gui')
module.exports.color = require('./vendor/dat.color')


//////////////////
// WEBPACK FOOTER
// ./node_modules/dat-gui/index.js
// module id = 21
// module chunks = 0